<div style="padding-top:10px">
    <div class="panel panel-default" style="align-items: right; border: NONE">
        <button type="button" class="btn btn-default btn-xs" (click)="apply( 'yes' )">
            Download {{title}} CSV
        </button>
    </div>

</div>